import React from 'react';
import { ColumnListContainer } from 'modules/shared-ui/components';
import { ProductThumbnailLoader } from '../../product/product-thumbnail';

import styles from './vertical-product-list-component.module.css';

export const VerticalProductListLoader: React.FC<{ headerChildren?: React.ReactNode }> = React.memo(
    ({ headerChildren }: { headerChildren?: React.ReactNode }) => {
        return (
            <div className={styles.container}>
                <ColumnListContainer
                    options={{
                        mobile: [1, 2],
                        tablet: [2, 3],
                        computer: [3, 4],
                    }}
                    items={[...Array.from(Array(10).keys())]}
                    itemRenderer={(number: number) => {
                        return (
                            <div className={`${styles.ficheProductContainer}`} key={number}>
                                <ProductThumbnailLoader />
                            </div>
                        );
                    }}
                    headerChildren={headerChildren}
                />
            </div>
        );
    },
);
